import React from "react";
import Button from "../../../../components/base/Button";

export default function HeroSection() {
    return (
        <section className="relative overflow-hidden bg-[linear-gradient(208.86deg,_#499FB2_81.18%,_#7DD8C4_101.76%)]">
            <div className="mx-auto w-full max-w-[1514px] px-4 pb-10 sm:px-6 sm:pb-14">
                <div className="grid items-center gap-10 lg:grid-cols-[1fr_1.1fr] lg:gap-0">
                    {/* LEFT */}
                    <div className="text-white">
                        <div className="flex items-center pt-28 gap-4">
                            <div className="font-['Helvetica'] text-[24px] font-bold uppercase tracking-[0.15em]">
                                FAR INFRARED
                            </div>
                            <div className="font-['Helvetica'] text-[18px] font-normal tracking-[0.04em]">
                                32-37°C
                            </div>
                        </div>

                        <div className="mt-3 h-px pt-0.5 w-full max-w-[649px] bg-white/50"/>

                        <div className="mt-6 flex flex-wrap gap-x-4 gap-y-2 pl-[30px]">
                            <div
                                className="font-['Helvetica'] text-[28px] font-bold uppercase leading-none sm:text-[34px]">
                                HOT
                            </div>

                            {/* YOGA + */}
                            <div className="flex items-baseline gap-3">
                                <div
                                    className="font-['Helvetica'] text-[44px] leading-none font-bold uppercase tracking-[0.06em] sm:text-[64px]">
                                    YOGA
                                </div>
                                <div
                                    className="font-['Helvetica'] text-[44px] leading-none font-bold tracking-[0.06em] sm:text-[50px]">
                                    +
                                </div>
                            </div>

                            {/* FITNESS FUSION */}
                            <div className="flex items-baseline gap-3 pl-[150px]">
                                <div
                                    className="font-['Helvetica'] text-[44px] leading-none font-bold uppercase tracking-[0.06em] sm:text-[64px]">
                                    FITNESS
                                </div>
                                <div
                                    className="font-['Helvetica'] text-[24px] leading-none font-bold uppercase tracking-[0.06em] sm:text-[34px]">
                                    FUSION
                                </div>
                            </div>
                        </div>

                        <div className="mt-6 h-px w-full max-w-[649px] bg-white/90"/>

                        <div className="mt-10 flex justify-center">
                            <Button
                                size="sm"
                                className="h-[48px] min-w-[200px] bg-white px-8 font-bold text-[#2E5984]"
                                style={{textAlign: "center", color: "#2E5984", fontWeight:"bold", fontSize: "22px", borderRadius: "40px"}}
                            >
                                Opening Feb 2026 - Join Now
                            </Button>
                        </div>
                    </div>

                    {/* RIGHT */}
                    <div className="relative lg:flex lg:justify-end">
                        <div
                            className="
                relative w-full max-w-[860px]
                overflow-hidden
                rounded-[12px] lg:rounded-[0px]
                shadow-[0_20px_60px_rgba(0,0,0,0.18)]
                lg:shadow-none
              "
                            style={{
                                // на desktop — диагональ, на mobile можно оставить прямоугольник (clipPath отключим через lg)
                                clipPath: "none",
                            }}
                        >
                            <div
                                className="hidden lg:block"
                                style={{
                                    position: "absolute",
                                    inset: 0,
                                    clipPath: "polygon(12% 0, 100% 0, 100% 100%, 0 100%)",
                                    overflow: "hidden",
                                }}
                            >
                                <img
                                    src="/img/home_hero_section.png"
                                    alt="Yoga class"
                                    className="h-full w-full object-cover"
                                    draggable={false}
                                />
                            </div>

                            {/* Mobile/tablet image (no diagonal, cleaner) */}
                            <img
                                src="/img/home_hero_section.png"
                                alt="Yoga class"
                                className="block h-[260px] w-full object-cover lg:hidden sm:h-[340px]"
                                draggable={false}
                            />

                            {/* Desktop image is handled by absolute clipped div above */}
                            <div className="hidden lg:block pb-[60%]" />
                        </div>
                    </div>
                </div>

                {/* Bottom description */}
                <div className="mx-auto mt-12 max-w-[1200px] px-2 text-center text-white">
                    <p className="font-['Helvetica'] text-[18px] leading-[24px] tracking-[0.04em] sm:text-[22px] sm:leading-[30px] lg:text-[28px] lg:leading-[32px]">
                        Offering over 12 new infrared heated classes from traditional, flow,
                        Hatha yoga, fitness fusion, Animal flow and intensive fitness.
                        Experience the wellness, energy, healing power and relaxation of far
                        infrared deep heat
                    </p>
                </div>
            </div>
        </section>
    );
}
